import { AnimatedSection } from "./AnimatedSection";
import { Lock } from "lucide-react";

export function Exclusivity() {
  return (
    <section className="py-24 md:py-36 bg-[#050A07] relative" data-testid="exclusivity-section">
      {/* Minimal line accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#22C55E]/30 to-transparent" />

      <div className="max-w-4xl mx-auto px-6 text-center">
        <AnimatedSection>
          <Lock className="w-8 h-8 text-[#22C55E]/50 mx-auto mb-8" />
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Early Access Network
          </h2>
          <p className="mt-8 text-[#A1B2A8] text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
            We are onboarding a limited number of buyers and suppliers to build a high-quality trade network.
          </p>
          <p className="mt-4 text-[#A1B2A8] text-base lg:text-lg leading-relaxed max-w-2xl mx-auto">
            Applications are reviewed and approved selectively.
          </p>
          <p className="mt-6 text-white font-['Outfit'] font-semibold text-lg">
            Not all participants will be accepted.
          </p>
        </AnimatedSection>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#22C55E]/30 to-transparent" />
    </section>
  );
}
